import React from 'react';
import CloseIcon from 'src/assets/hosLogs/close.svg';

import './filterItem.scss';

interface Props {
  title: string;
  onClick?: () => void;
}

export const FilterItem: React.FC<Props> = ({ title, onClick }) => {
  return (
    <div className="filter-item">
      {title}
      <img onClick={onClick} className="filter-item__icon" src={CloseIcon} alt="certifyLogIcon" />
    </div>
  );
};
